/**
 * Banner ben visibile "posta in cancellazione": mostrato sotto la TopBar in
 * TUTTE le viste quando ci sono mail nel parcheggio 48h. Cliccandolo si apre
 * la vista "In cancellazione" dove si puo' annullare o forzare.
 */
import { useQuery } from '@tanstack/react-query';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import { deletionApi } from '../../lib/api';
import { useUiStore } from '../../store/ui';

// Tempo residuo compatto verso la prossima cancellazione automatica.
function remainingLabel(iso: string | null): string | null {
  if (!iso) return null;
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return 'imminente';
  const h = Math.floor(diff / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function DeletionAlert() {
  const setCurrentView = useUiStore((s) => s.setCurrentView);
  const currentView = useUiStore((s) => s.currentView);

  const { data } = useQuery({
    queryKey: ['deletion-alert'],
    queryFn: () => deletionApi.alert() as Promise<{ count: number; next_purge_after: string | null }>,
    refetchInterval: 60_000,
  });

  const count = data?.count ?? 0;
  // Niente banner se non c'e' nulla o se siamo gia' nella vista dedicata.
  if (count <= 0 || currentView === 'deletion') return null;
  const remaining = remainingLabel(data?.next_purge_after ?? null);

  return (
    <button
      onClick={() => setCurrentView('deletion')}
      className="flex w-full items-center justify-center gap-2 border-b border-red-700 bg-red-600 px-4 py-1.5 text-sm font-medium text-white transition hover:bg-red-700"
      title="Vai alla posta in cancellazione"
    >
      <AlertTriangle size={14} className="shrink-0" />
      <span>
        <strong>{count}</strong> {count === 1 ? 'mail verrà cancellata' : 'mail verranno cancellate'}{' '}
        definitivamente{remaining ? ` (prossima tra ${remaining})` : ''} — clicca per gestire o
        annullare
      </span>
      <ChevronRight size={14} className="shrink-0" />
    </button>
  );
}
